import { PageHero } from "@/components/Section";
import CategoryGrid from "@/components/CategoryGrid";
import { PortalButton } from "@/components/PortalButton";
import { Reveal } from "@/components/Reveal";
import { Search } from "lucide-react";

const FILTERS = ["Category", "Brand", "Country of Origin", "Package Size", "Availability", "Price Range", "Frequently Purchased", "New", "Promotional"];

export default function ProductCategories() {
  return (
    <>
      <PageHero
        chapter="Product Categories"
        title="More than 500 SKUs from one wholesale location"
        lead="Everything your restaurant needs — food ingredients, packaging, cleaning and kitchen essentials — organized into the categories your kitchen orders from every week."
      >
        <PortalButton variant="butter" testId="catalogue-order-btn">Start Ordering</PortalButton>
      </PageHero>

      <section className="py-24 md:py-32 bg-cream">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
          {/* Search + filter chips (visual) */}
          <Reveal className="mb-10">
            <div className="flex items-center gap-2 rounded-2xl border border-forest/15 bg-white px-4 py-3.5 max-w-2xl">
              <Search className="h-5 w-5 text-forest/50" />
              <span className="text-sm text-forest/50">Search by product name, SKU, brand or category…</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              {FILTERS.map((f, i) => (
                <span key={f} className={`text-xs font-medium rounded-full px-3.5 py-2 border ${i === 0 ? "bg-forest text-butter border-forest" : "border-forest/20 text-forest/70"}`}>{f}</span>
              ))}
            </div>
            <p className="text-xs text-forest/50 mt-3 font-mono-accent">Live pricing and stock are shown once you log into an approved wholesale account.</p>
          </Reveal>

          <CategoryGrid />
        </div>
      </section>

      <section className="py-16 bg-forest text-cream">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="font-display text-2xl md:text-3xl text-butter max-w-xl">Need a product that isn&apos;t listed? We regularly source new items for regular customers.</h3>
          <PortalButton variant="butter" testId="categories-request-pricing-btn">Request Wholesale Pricing</PortalButton>
        </div>
      </section>
    </>
  );
}
